import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import SimpleLayout from "../../../components/Layout/Simple";
import ConfirmEmailContent from "../../../components/Pages/Auth/ConfirmEmail";

const { displayName } = config;

export default function ConfirmEmail({ ...props }): React.ReactNode {
  useEffect(() => {
    document.title = `${displayName}: Email confirmed successfully`;
  }, []);

  return (
    <SimpleLayout>
      <ConfirmEmailContent {...props} />
    </SimpleLayout>
  );
}
